module.exports = __webpack_public_path__ + "img/logo.cd2ab83b.png";